import { Swiper } from './swiper-BS-F1fmK.js';
import { N as Navigation } from './navigation-yBYgHuIg.js';
import { A as A11y } from './a11y-OGB5p3A3.js';
import './utils-DfPPEfgu.js';
import './create-element-if-not-defined-BQEJuiIf.js';
import './classes-to-selector-BKH7ThcP.js';

class FeaturedBlog extends HTMLElement {
  #swiper = this.querySelector('.swiper');
  #nextButton = this.querySelector('.swiper-next');
  #prevButton = this.querySelector('.swiper-prev');

  connectedCallback() {
    new Swiper(this.#swiper, {
      modules: [A11y, Navigation],
      slidesPerView: 1.2,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      spaceBetween: 16,
      navigation: {
        nextEl: this.#nextButton,
        prevEl: this.#prevButton,
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          slidesOffsetBefore: 40,
          slidesOffsetAfter: 40,
        },
      },
    });
  }
}

customElements.define('featured-blog', FeaturedBlog);
